import { DoNotCallRestrictionType } from 'infrastructure/enums';
import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const clinicInstructionsValidationSchema = () =>
  createValidationSchema({
    criticalBusinessHours: commonValidationSchemas.string({ nullable: true }),
    criticalAfterHours: commonValidationSchemas.string({ nullable: true }),
    businessHours: commonValidationSchemas.string({ nullable: true }),
    afterHours: commonValidationSchemas.string({ nullable: true }),
    contactMethod: commonValidationSchemas.string({ nullable: true }),
    contactMethodValue: commonValidationSchemas.string({ nullable: true }),
    doNotCallRestrictionType: commonValidationSchemas.string({
      nullable: true,
    }),
    ccmDoNotCallRestrictionType: commonValidationSchemas.string({
      nullable: true,
    }),
    doNotCallStartTime: commonValidationSchemas
      .string({ nullable: true })
      .when(['doNotCallRestrictionType'], {
        is: (dncType: string) =>
          dncType === DoNotCallRestrictionType.LimitedHours,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema,
      }),
    doNotCallEndTime: commonValidationSchemas
      .string({ nullable: true })
      .when(['doNotCallRestrictionType'], {
        is: (dncType: string) =>
          dncType === DoNotCallRestrictionType.LimitedHours,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema,
      }),
    ccmDoNotCallStartTime: commonValidationSchemas
      .string({ nullable: true })
      .when(['ccmDoNotCallRestrictionType'], {
        is: (dncType: string) =>
          dncType === DoNotCallRestrictionType.LimitedHours,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema,
      }),
    ccmDoNotCallEndTime: commonValidationSchemas
      .string({ nullable: true })
      .when(['ccmDoNotCallRestrictionType'], {
        is: (dncType: string) =>
          dncType === DoNotCallRestrictionType.LimitedHours,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema,
      }),
    notes: commonValidationSchemas.string({ required: true, nullable: true }),
    dateNoteLogged: commonValidationSchemas.string({
      required: true,
      nullable: true,
    }),
  });
